import { render, staticRenderFns } from "./SchemaTabs.vue?vue&type=template&id=e81f21e0&scoped=true"
import script from "./SchemaTabs.vue?vue&type=script&lang=js"
export * from "./SchemaTabs.vue?vue&type=script&lang=js"
import style0 from "./SchemaTabs.vue?vue&type=style&index=0&id=e81f21e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81f21e0",
  null
  
)

export default component.exports